export default {
  ACTIVATION_EXPIRED: "ACTIVATION_EXPIRED",
  ACTIVATION_EXPIRING: "ACTIVATION_EXPIRING",
  ACTIVATION_NEW: "ACTIVATION_NEW",
  EBOOK_NEW: "EBOOK_NEW",
  EVALUATION_EXPIRED: "EVALUATION_EXPIRED",
  EVALUATION_EXPIRING: "EVALUATION_EXPIRING",
  EVALUATION_NEW: "EVALUATION_NEW",
  INDEX_NEW: "INDEX_NEW",
};
